import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Column } from 'components/shared/Layout';
import classOfService from 'constants/propTypes/classOfService';
import { directions } from 'constants/booking';

import SegmentInfo from './SegmentInfo';

const SegmentSummaryColumn = ({ extras = [], direction }) => (
  <>
    <Column span={8} data-testid={`extras-segment-summary-column-${direction}`}>
      {extras.length > 0 && (
        <>
          <h3>
            <FormattedMessage id={`journeySummary.${direction}`} />
          </h3>
          {extras.map((extra) => (
            <SegmentInfo key={`${extra.origin.shortCode}-${extra.destination.shortCode}`} {...extra} />
          ))}
        </>
      )}
    </Column>
  </>
);

SegmentSummaryColumn.propTypes = {
  extras: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      departsAt: PropTypes.string,
      arrivesAt: PropTypes.string,
      origin: PropTypes.shape({
        uic: PropTypes.string,
        shortCode: PropTypes.string,
        name: PropTypes.string
      }),
      destination: PropTypes.shape({
        uic: PropTypes.string,
        shortCode: PropTypes.string,
        name: PropTypes.string
      }),
      classOfService: classOfService,
      trainNumber: PropTypes.string,
      extras: PropTypes.arrayOf(PropTypes.object)
    })
  ),
  direction: PropTypes.oneOf(directions).isRequired
};

export default SegmentSummaryColumn;
